<template>
  <li :class="{active:tab.active}">
    <a href="javascript:void(0)" :class="{disabled: !tab.checked}">
      <div class="circle-back">
        <div class="wizard-icon-circle md"
             role="tab"
             :tabindex="tab.checked ? 0 : ''"
             :id="`step-${tab.tabId}`"
             :aria-controls="tab.tabId"
             :aria-disabled="tab.active"
             :aria-selected="tab.active"
             :class="{checked: tab.checked,square_shape:isStepSquare, tab_shape:isTabShape}"
             :style="[tab.checked ? stepCheckedStyle : {}, tab.validationError ? errorStyle : {}]">
          <transition :name="transition" mode="out-in">
            <div v-if="tab.active" class="wizard-icon-container"
                 :style="[tab.active ? iconActiveStyle: {}, tab.validationError ? errorStyle : {}]">
              <slot name="active-step">
                <span v-if="tab.icon" :class="tab.icon" class="wizard-icon"></span>
                <span v-else class="wizard-icon">{{index + 1}}</span>
              </slot>
            </div>
            <slot v-if="!tab.active">
              <span v-if="!tab.active && tab.checked" class="wizard-icon fct-admin-icon-check" style="font-weight: 300; font-size: 12px;"></span>
              <span v-else class="wizard-icon">{{index + 1}}</span>
            </slot>
          </transition>
        </div>
      </div>
    </a>
  </li>
</template>
<script>
  export default {
    name: 'wizard-step',
    props: {
      tab: {
        type: Object,
        default: () => {

        }
      },
      transition: {
        type: String,
        default: ''
      },
      index: {
        type: Number,
        default: 0
      }
    },
    computed: {
      iconActiveStyle() {
        return {
          border: '4px solid #fff',
          backgroundColor: '#3d83ee',
        }
      },
      stepCheckedStyle() {
        return {
          border: '#fff',
          backgroundColor: '#fff',
          color: '$active-color',
          boxShadow: '0px 5px 9px 1px rgba(1, 1, 1, 0.07)'
        }
      },
      errorStyle() {
        return {
          borderColor: this.tab.errorColor,
          backgroundColor: this.tab.errorColor
        }
      },
      stepTitleStyle() {
        let isError = this.tab.validationError
        return {
          color: isError ? this.tab.errorColor : this.tab.color
        }
      },
      isStepSquare() {
        return this.tab.shape === 'square'
      },
      isTabShape() {
        return this.tab.shape === 'tab'
      }
    }
  }
</script>
<style>
</style>
